 import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { ButtonModule, ListGroupModule, OffcanvasModule, PaginationModule, TableModule } from '@coreui/angular';
import { TranslateModule } from '@ngx-translate/core';
import { DashboardMccdComponent } from './dashboard/dashboard-mccd/dashboard-mccd.component';
import { DashboardUcodComponent } from './dashboard/dashboard-ucod/dashboard-ucod.component';
import { ToolsUcodComponent } from './tools/tools-ucod/tools-ucod.component';
// import { SystemComponent } from './dashboard/system/system.component';
import { DualVersionIcdComponent } from './DualVersionICD/dual-version-icd/dual-version-icd.component';
import { DualVersionIcfComponent } from './DualVersionICD/dual-version-icf/dual-version-icf.component';
import { DualVersion9IcdComponent } from './DualVersionICD/dual-version9-icd/dual-version9-icd.component';
import { Icd10Component } from './icd10/icd10.component';
import { Icd9Component } from './icd9/icd9.component';
import { IcfComponent } from './icf/icf.component';
import { InstructionIcd10Component } from './instruction-icd10/instruction-icd10.component';
import { InstructionIcd9Component } from './instruction-icd9/instruction-icd9.component';
import { InstructionIcfComponent } from './instruction-icf/instruction-icf.component';
import { NotificationComponent } from './notification/notification.component';
import { SearchGlobalDetailComponent } from './search-global-detail/search-global-detail.component';
import { SearchGlobalComponent } from './search-global/search-global.component';
import { SearchIcd9Component } from './search-icd9/search-icd9.component';
import { SearchIcfComponent } from './search-icf/search-icf.component';
import { SearchComponent } from './search/search.component';

import{ Icd10v3Component } from'./icd10v3/icd10v3.component'
import {
    SearchRoutingModule,
    NotificationRoutingModule,
    DashboardRoutingModule,
    Icd9RoutingModule,
    ICD10RoutingModule,
    ICFRoutingModule,
    ToolsRoutingModule,
    LoincRoutingModule // Import the new LoincRoutingModule
} from './who-routing.module';
import { HighchartsChartModule } from "highcharts-angular";
import {MatSelectModule} from '@angular/material/select';
import { RouterModule } from '@angular/router';

import { LoincTableComponent } from './loinc/loinc-table/loinc-table.component';
// import { LoincMapToComponent } from './loinc/loinc-map-to/loinc-map-to.component';
// import { LoincPartComponent } from './loinc/loinc-part/loinc-part.component';
// import { LoincPartLinkComponent } from './loinc/loinc-part-link/loinc-part-link.component';
import { LoincPanelsFormsComponent } from './loinc/loinc-panels-forms/loinc-panels-forms.component';
// import { LoincAnswerListsComponent } from './loinc/loinc-answer-lists/loinc-answer-lists.component';
// import { LoincAnswersComponent } from './loinc/loinc-answers/loinc-answers.component';
// import { LoincAnswerListLinksComponent } from './loinc/loinc-answer-list-links/loinc-answer-list-links.component';
import { LoincListDisplayComponent } from './loinc/loinc-list-display/loinc-list-display.component';
import { LoincDetailDisplayComponent } from './loinc/loinc-detail-display/loinc-detail-display.component';
 import { MatCheckboxModule } from '@angular/material/checkbox';


export class CustomPaginatorIntl extends MatPaginatorIntl {
  constructor() {
    super();

    this.itemsPerPageLabel = 'Số bản ghi mỗi trang: ';
  }

}


@NgModule({
  imports: [
    CommonModule,
    SearchRoutingModule,
    FormsModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    PaginationModule,
    TableModule,
  ],
    declarations: [
        SearchGlobalComponent,
        SearchGlobalDetailComponent
    ],
})
export class SearchGlobalModule {}

@NgModule({
    imports: [
        RouterModule,
        FormsModule,
        ToolsRoutingModule
    ],
    declarations: [
        ToolsUcodComponent
    ]
})
export class ToolsModule {}

@NgModule({
    imports: [
        CommonModule,
        NotificationRoutingModule
    ],
    declarations: [
        NotificationComponent
    ]
})
export class NotificationModule {}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatButtonToggleModule,
        MatButtonModule,
        MatTableModule,
        MatPaginatorModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        HighchartsChartModule,
        DashboardRoutingModule,
    ],
    declarations: [
        DashboardUcodComponent,
        DashboardMccdComponent
    ]
})
export class DashboardModule {}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatTreeModule,
        MatIconModule,
        MatButtonModule,
        OffcanvasModule,
        ButtonModule,
        NgOptimizedImage,
        Icd9RoutingModule
    ],
    declarations: [
        Icd9Component,
        DualVersion9IcdComponent,
        InstructionIcd9Component,
        SearchIcd9Component
    ]
})
export class Icd9Module {}

@NgModule({
    imports: [
        CommonModule,
        MatTreeModule,
        MatIconModule,
        MatButtonModule,
        ButtonModule,
        OffcanvasModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        NgOptimizedImage,
        ICD10RoutingModule
    ],
    declarations: [
        Icd10Component,
        DualVersionIcdComponent,
        InstructionIcd10Component,
        SearchComponent
    ]
})
export class Icd10Module {}

@NgModule({
    imports: [
        CommonModule,
        MatTreeModule,
        MatButtonModule,
        MatIconModule,
        ButtonModule,
        OffcanvasModule,
        FormsModule,
        NgOptimizedImage,
        ICFRoutingModule
    ],
    declarations: [
        IcfComponent,
        DualVersionIcfComponent,
        InstructionIcfComponent,
        SearchIcfComponent
    ]
})
export class IcfModule {}



@NgModule({
    imports: [
        CommonModule,
        LoincRoutingModule,
        FormsModule,
        TableModule,
        RouterModule,
        MatPaginatorModule,
        ReactiveFormsModule,
        ListGroupModule,
        MatFormFieldModule,
        MatSelectModule,
        MatCheckboxModule,
        ButtonModule
    ],
    declarations: [
        LoincListDisplayComponent,
        LoincDetailDisplayComponent,
        LoincTableComponent,
        // LoincMapToComponent,
        // LoincPartComponent,
        // LoincPartLinkComponent,
        LoincPanelsFormsComponent,
        // LoincAnswerListsComponent,
        // LoincAnswersComponent,
        // LoincAnswerListLinksComponent
    ]
})
export class LoincModule {}